// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2Mt43","loaderOuter":"PageOverlayLoader_loaderOuter__2tZxb"};